import swal from 'sweetalert2'

export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name="${name}"]`)
  if (element) {
    return element.getAttribute("content")
  }
}

export function findElement(root, selector) {
  if (typeof root == "string") {
    selector = root
    root = document
  }
  return root.querySelector(selector)
}

export function toArray(value) {
  if (Array.isArray(value)) {
    return value
  } else if (Array.from) {
    return Array.from(value)
  } else {
    return [].slice.call(value)
  }
}

export function removeElement(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export function insertAfter(el, referenceNode) {
    return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}


export function fireConfirmPopup(popupConfig) {
  const swalCustomStyle = swal.mixin({
    customClass: {
      confirmButton: 'btn btn--primary',
      cancelButton: 'btn btn--danger'
    },
    buttonsStyling: false
  })

  let promise = new Promise(function(resolve, reject) {
    swalCustomStyle.fire({
      title: popupConfig.title || '¿Estas Seguro?',
      text: popupConfig.text || 'Vas a eliminar este documento',
      icon: popupConfig.icon || 'warning',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then(res => {
      resolve(res.isConfirmed);
    }).catch(e => {
      reject(e)
    })
  });
  return promise;
}


export function fireToast(toastConfig) {
  const Toast = swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', swal.stopTimer)
      toast.addEventListener('mouseleave', swal.resumeTimer)
    }
  })

  Toast.fire({
    icon: toastConfig.icon,
    title: toastConfig.title
  })
}